import { render, staticRenderFns } from "./ClientBillEdit.vue?vue&type=template&id=9b210348&"
import script from "./ClientBillEdit.js?vue&type=script&lang=js&"
export * from "./ClientBillEdit.js?vue&type=script&lang=js&"
import style0 from "./ClientBillEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports